import moment from 'moment-timezone';
import { DATE_FORMAT, DATE_FORMAT_EVENTS, SHORT_TIME_FORMAT_24, DATE_TIME_FORMAT_24 } from './Constants';

export function formatForCalendar (date){
    return date? new Date (date+" 00:00"): date;
}

export function formatDateInput(date) {
    return moment(date).format(DATE_FORMAT_EVENTS);
}

export function formatTimeInput(time) {
    return moment(time).format(SHORT_TIME_FORMAT_24);
}

export function formatDateTimeEvents(date, time) {
    var formatDate = date.format(DATE_FORMAT);
    return moment(`${formatDate} ${time}`);
}

export function getMinDate(dateTime) {
    return moment(dateTime).add(-1, 'years').startOf('day');
}

export function formatDateTime(datetime) {
    return moment(datetime).format(DATE_TIME_FORMAT_24);
}

export function formatPhoneNumber(phone) {
    if (!phone || phone.length < 10) {
        return phone;
    }

    const number1 = phone.slice(phone.length - 4, phone.length);
    const number2 = phone.slice(phone.length - 7, phone.length - 4);
    const number3 = phone.slice(phone.length - 10, phone.length - 7);
    const number4 = phone.slice(0, phone.length - 10);

    return `${number4} (${number3})-${number2}-${number1}`
}

export function formatValue(value) {
    return value? value : '';
}

export function formatNumber(value, fix) {
    var result = ''
    if (value || value === 0) {
        result = Number(value).toFixed(fix);
    }
    return result;
}

export function formatAlphaNumeric(value) {
    var result = '';
    var filter = 'abcdefghijklmnñopqrstuvwxyzABCDEFGHIJKLMNÑOPQRSTUVWXYZ1234567890';

    for (const element of value){
        if (filter.indexOf(element) !== -1) {
            result += element;
        }
    }

    return result;
}

export function reserveExceptionResponse (responseData) {
    const exceptionAlreadyReserved1 = 'Exception cannot be reserved because is already reserved';
    const exceptionAlreadyReserved2 = 'Exception cannot be reserved because is reserved by another user';
    const exceptionAlreadyReservedResponse = 'Selected exception was already reserved by another user. Please refresh the view.';
    
    return responseData === exceptionAlreadyReserved1 || responseData === exceptionAlreadyReserved2 ? exceptionAlreadyReservedResponse : responseData;
}